var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"rules":_vm.textFieldErrors(),"type":"text","value":_vm.value,"model":_vm.value,"label":_vm.label,"mask":_vm.mask,"placeholder":_vm.placeholder,"disabled":_vm.disabled,"color":'#00BFB3',"height":'44',"persistent-hint":true,"background-color":'#EFEFEF'},on:{"input":function($event){return _vm.$emit('input', $event)}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29281e58","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/fields/EditText.vue
// module id = null
// module chunks = 